module.exports = __webpack_public_path__ + "static/power-up-6287510a1c5bb7166f6810b45ffa2b30.jpg";